// src/types/routes.ts
export enum RoutePaths {
  HOME = '/',
  PAPER_SHEET = '/:roomName',

  ROUND = '/round',
  NOTIF = '/notif',
  FARITANY = '/faritany/:roomName',
  ACTIVE_USER = '/active-user',
  GAME_RULES = '/game-rules',
  HISTORY = '/history',
  ACCOUNT = '/account',
  SPECTATE = '/spectate/:roomName',
}

export interface RouteConfig {
  path: string;
  element: React.ReactNode;
  index?: boolean;
  children?: RouteConfig[];
}
